import { gql } from "@apollo/client"

export const Account = gql`
  query Account {
    me {
      emailAddress
      firstName
      lastName
      mobilePhoneNumber
      mobileCountryPrefix
      regionCode
    }
  }
`

export const UpdateAccountProfile = gql`
  mutation UpdateAccountProfile($input: UpdateAccountProfileInput!) {
    updateAccountProfile(input: $input) {
      success
      errors
    }
  }
`
